const SUCCESS_CODE = '200';

export function get(url, data = {}, options) {
  return fetch('GET',url,data,options);
}

export function post(url, data, options) {
  return fetch('POST',url,data,options);
}

export function jsonp(url, data, options) {
  return fetch('JSONP',url,data,options);
}

export function fetch(type='GET',url, data={}){
  let options={
    startTime:new Date(),
    hostName:url.split('?')[0]
  };
  type = type.toUpperCase();
  let _ajax = type=='JSONP'?$.ajax({url,data,dataType:'jsonp'}):$.ajax({type,url,data});
  return _ajax.then(parseJSON).then((res) => checkResponse(res,options));
}


function AbstractResponse(response,error){
  if (response) {
    this.code = response.code;
    this.data = response.data||response.result;
  }
  this.error = error || null;
}

/**
 * 错误时候的响应对象
 * @return {null} null
 */
function ErrorResponse(error){
  AbstractResponse.call(this, null,error);
}

/**
 * 接口正常时的返回对象
 * @return {null} null
 */
function SuccessResponse(response){
  AbstractResponse.call(this,response,null);
}

function checkResponse(response,options){
  const { code, message } = response;
  if (code == SUCCESS_CODE) {
    //retcode上报接口成功
    setTimeout(()=>window.__WPO&&window.__WPO.retCode(options.hostName, true, new Date()-options.startTime, 'code200', 'success'));
    return new SuccessResponse(response);
  }else{  //错误处理
    //retcode上报接口失败
    window.__WPO&&window.__WPO.retCode(options.hostName, false, new Date()-options.startTime, 'codenot200', message);
  }
}

function parseJSON(response) {
  if(typeof response=='string') response = JSON.parse(response);
  return response;
}




// WEBPACK FOOTER //
// ./src/helper/http.js